var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page-tab transaction-container",
      staticStyle: { height: "540px" },
    },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "dialog",
          "form-props": { labelPosition: "left" },
          immediate: false,
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "table-attrs": _vm.tableAttrs,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c("div", { staticClass: "total-stats" }, [
                  _c("div", { staticClass: "total-stats-item" }, [
                    _c("span", [_vm._v("总下注")]),
                    _c("span", { staticClass: "total-stats-value" }, [
                      _vm._v(
                        _vm._s(_vm.formatAmount(_vm.stats.bet_amount_total))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "total-stats-item" }, [
                    _c("span", [_vm._v("总输赢")]),
                    _c("span", { staticClass: "total-stats-value" }, [
                      _vm._v(
                        _vm._s(_vm.formatAmount(_vm.stats.win_amount_total))
                      ),
                    ]),
                  ]),
                  _c("span", { staticClass: "total-update-time" }, [
                    _vm._v(
                      "(最后更新时间" +
                        _vm._s(
                          _vm.formatTimestamp(_vm.stats.bet_info_updated_at)
                        ) +
                        ")"
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "winAmount",
            fn: function ({ row }) {
              return [
                _c(
                  "span",
                  {
                    class:
                      (row.win_amount || 0) >= 0
                        ? "text-positive"
                        : "text-negative",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s((row.win_amount || 0) >= 0 ? "+" : "") +
                        _vm._s(_vm.formatAmount(row.win_amount)) +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "betAmount",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm.formatAmount(row.bet_amount)))]
            },
          },
          {
            key: "createdAt",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm.formatTimestamp(row.created_at)))]
            },
          },
          {
            key: "betStatus",
            fn: function ({ row }) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      size: "mini",
                      type:
                        _vm.formatStatus(row) === "Win" ? "success" : "danger",
                    },
                  },
                  [_vm._v(_vm._s(_vm.formatStatus(row)))]
                ),
              ]
            },
          },
          {
            key: "betId",
            fn: function ({ row }) {
              return [
                _vm._v(_vm._s(row.bet_id != null ? String(row.bet_id) : "--")),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }